import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import calendar from "../../images/calendar.svg";
import { useState } from "react";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { theme } from "../../utils/theme";
import * as appActions from "../../redux/actions/appActions";
import gcal from "../../images/google_calendar.png";
import mcal from "../../images/microsoft_calendar.png";
import { getCalendarVerificationLinkMS } from "../../functions";
import { getCalendarVerificationLink } from "../../functions";
// import { useTour } from "@reactour/tour";
import { fetchUserData } from "../../services/UserService"

const IntegrateCalendarPopup = () => {
  const { calendarMeetings } = useSelector((state) => state.meetingsReducer);
  const dispatch = useDispatch();
  const [calendarAuthLoading, setCalendarAuthLoading] = useState(false);
  const [calendarAuthLoadingMs, setCalendarAuthLoadingMs] = useState(false);

  return (
    <div className="fixed z-40 h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.2)] backdrop-blur-sm flex items-center justify-center">
      <div className="flex flex-col items-end gap-[10px] max-w-[80%] w-[500px] xl:w-[600px]">
        <div className="bg-white shadow-md rounded-lg overflow-hidden">
          <div
            style={{ backgroundColor: theme.color }}
            className="p-[20px] text-white text-base sm:text-lg xl:text-2xl text-center 2xl:text-3xl"
          >
            {calendarMeetings?.detail !== "Invalid token" &&
            calendarMeetings !== null
              ? "Calendar Synced!!"
              : "Sync Your Calendar!!"}
          </div>
          <div className="w-[50%] mx-auto">
            <img src={calendar} alt="Calendar" />
          </div>
          {(calendarMeetings?.detail === "Invalid token" ||
            calendarMeetings === null) && (
            <div className="px-[20px] text-sm sm:text-base 2xl:text-lg text-justify">
              Sync your calendar to let MeetMinutes join all your scheduled
              meetings. It will help you stay on top of your action items and
              deadlines.
            </div>
          )}
          <div
            onClick={() => {
              if (
                calendarMeetings?.detail === "Invalid token" ||
                calendarMeetings === null
              ) {
                setCalendarAuthLoading(true);
                fetchUserData(dispatch);
                getCalendarVerificationLink({
                  user_id: localStorage.getItem("@auth"),
                })
                  .then((res) => {
                    window.open(res.auth_url);
                  })
                  .catch(() => {
                    toast.error("Some error occured, please try later!");
                  })
                  .finally(() => {
                    setCalendarAuthLoading(false);
                  });
              } else {
                import("../../redux/actions/appActions").then((ac) =>
                  dispatch(ac.integrateCalendarPopup(false))
                );
              }
            }}
            // style={{ backgroundColor: theme.color }}
            className="text-black m-[20px] rounded-md px-[15px] w-fit py-[10px] flex items-center justify-center cursor-pointer first-step border-2 border-[#07457F] hover:border-sky-500"
          >
            {calendarAuthLoading ? (
              <CircularProgress
                style={{ color: "white", width: "20px", height: "20px" }}
              />
            ) : calendarMeetings?.detail !== "Invalid token" &&
              calendarMeetings !== null ? (
              "Proceed"
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img className="w-[35px]" src={gcal} alt="Calendar" />
                <span style={{ marginLeft: "8px" }}>
                  Connect Google Calendar
                </span>
              </div>
            )}
          </div>
          {/* paste here MS calendar sync */}
          <div className="flex justify-between">
            <div
              onClick={() => {
                setCalendarAuthLoadingMs(true);
                fetchUserData(dispatch);
                getCalendarVerificationLinkMS({
                  user_id: localStorage.getItem("@auth"),
                })
                .then((res) => {
                  // console.log(res.data);
                  window.open(res.auth_url);
                })
                .catch(() => {
                  toast.error("Some error occured, please try later!");
                })
                .finally(() => {
                  setCalendarAuthLoadingMs(false);
                });
              }}
              // style={{ backgroundColor: theme.color }}
              className="text-black m-[20px] rounded-md px-[15px] w-fit py-[10px] flex cursor-pointer border-2 border-[#07457F] hover:border-sky-500"
            >
              {calendarAuthLoadingMs ? (
                <CircularProgress
                  style={{ color: "white", width: "20px", height: "20px" }}
                />
              ) : (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img className="w-[20px]" src={mcal} alt="Calendar" />
                  <span style={{ marginLeft: "8px" }}>
                    Connect Microsoft Calendar
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          // onClick={onSkipClick}
          onClick={() => {
            import("../../redux/actions/appActions").then((ac) => {
              dispatch(ac.integrateCalendarPopup(false));
            });
            dispatch(appActions.integrateCalendarPopup(false));
          }}
          className="sm:text-base text-sm cursor-pointer"
        >
          Skip
        </div>
      </div>
    </div>
  );
};

export default IntegrateCalendarPopup;
